// Mock data for TrainerLinked.in - LinkedIn clone for training professionals

export const mockUser = {
  id: "1",
  name: "Dr. Sarah Johnson",
  title: "Senior Corporate Training Specialist",
  location: "New York, NY",
  avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
  coverPhoto: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=200&fit=crop",
  connections: 1247,
  followers: 3421,
  about: "Passionate training professional with 10+ years of experience in corporate learning and development. Specialized in leadership training, soft skills development, and e-learning solutions.",
  experience: [
    {
      id: "1",
      title: "Senior Training Specialist",
      company: "TechCorp Solutions",
      duration: "2020 - Present",
      location: "New York, NY",
      description: "Lead training programs for 500+ employees across multiple departments"
    },
    {
      id: "2",
      title: "Learning & Development Coordinator",
      company: "Global Trainers Inc",
      duration: "2018 - 2020",
      location: "Boston, MA",
      description: "Developed and implemented training curricula for new hire programs"
    }
  ],
  skills: ["Leadership Training", "Corporate Training", "E-Learning", "Curriculum Development", "Adult Learning Theory"],
  certifications: ["Certified Professional in Learning and Performance (CPLP)", "Train the Trainer Certification"],
  education: [
    {
      school: "Harvard University",
      degree: "Master's in Adult Learning & Development",
      year: "2016"
    }
  ]
};

export const mockPosts = [
  {
    id: "1",
    author: {
      name: "Dr. Sarah Johnson",
      title: "Senior Corporate Training Specialist",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=50&h=50&fit=crop&crop=face"
    },
    content: "Just completed an amazing workshop on 'Building Resilient Teams' with 150 managers! The energy and engagement were incredible. Key takeaway: Resilience isn't just about bouncing back, it's about bouncing forward with new insights and stronger connections. 💪\n\n#TrainingLife #Leadership #TeamBuilding",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=500&h=300&fit=crop",
    timeAgo: "2 hours ago",
    likes: 47,
    comments: 12,
    shares: 8,
    isLiked: false
  },
  {
    id: "2",
    author: {
      name: "Mike Rodriguez",
      title: "Fitness & Wellness Trainer",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&h=50&fit=crop&crop=face"
    },
    content: "The future of training is here! 🚀 Virtual Reality is revolutionizing how we deliver safety training. Our latest VR module for workplace safety reduced training time by 40% while improving retention rates by 75%.\n\nWho else is experimenting with immersive training technologies?",
    video: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    timeAgo: "4 hours ago",
    likes: 89,
    comments: 23,
    shares: 15,
    isLiked: true
  },
  {
    id: "3",
    author: {
      name: "Emily Chen",
      title: "Digital Learning Specialist",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=50&h=50&fit=crop&crop=face"
    },
    content: "Microlearning is not just a buzzword - it's a game changer! 📚✨\n\nJust launched our bite-sized learning modules and the results are phenomenal:\n• 85% completion rate vs 45% for traditional courses\n• 3x better knowledge retention\n• Learners can access content on-demand\n\nWhat's your experience with microlearning approaches?",
    timeAgo: "6 hours ago",
    likes: 156,
    comments: 34,
    shares: 28,
    isLiked: false
  },
  {
    id: "4",
    author: {
      name: "James Thompson",
      title: "Executive Coach & Leadership Trainer",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50&h=50&fit=crop&crop=face"
    },
    content: "Proud to announce that our 'Future Leaders' program just graduated its 50th cohort! 🎓 Over 500 emerging leaders have gone through this transformative journey.\n\nSeeing participants grow from individual contributors to confident team leaders never gets old. The ripple effect of good training extends far beyond the classroom.",
    image: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=500&h=300&fit=crop",
    timeAgo: "8 hours ago",
    likes: 203,
    comments: 45,
    shares: 31,
    isLiked: false
  }
];

export const mockConnections = [
  {
    id: "1",
    name: "Alex Rodriguez",
    title: "Corporate Training Manager",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&h=50&fit=crop&crop=face",
    mutualConnections: 23,
    isConnected: true
  },
  {
    id: "2",
    name: "Lisa Zhang",
    title: "L&D Specialist",
    avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=50&h=50&fit=crop&crop=face",
    mutualConnections: 15,
    isConnected: false
  },
  {
    id: "3",
    name: "David Kumar",
    title: "Technical Training Lead",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50&h=50&fit=crop&crop=face",
    mutualConnections: 31,
    isConnected: true
  }
];

export const mockJobs = [
  {
    id: "1",
    title: "Senior Training Specialist",
    company: "Microsoft",
    location: "Seattle, WA",
    type: "Full-time",
    posted: "2 days ago",
    applicants: 47,
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_logo.svg/50px-Microsoft_logo.svg.png",
    description: "We're looking for an experienced training specialist to join our Learning & Development team..."
  },
  {
    id: "2",
    title: "Corporate Learning Designer",
    company: "Amazon",
    location: "Austin, TX",
    type: "Contract",
    posted: "1 day ago",
    applicants: 29,
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/50px-Amazon_logo.svg.png",
    description: "Join our team to design and develop innovative learning experiences for our global workforce..."
  }
];

export const mockCompanies = [
  {
    id: "1",
    name: "TrainingCorp Solutions",
    industry: "Corporate Training",
    size: "500-1000 employees",
    logo: "https://images.unsplash.com/photo-1560472355-536de3962603?w=50&h=50&fit=crop",
    followers: 12500,
    description: "Leading provider of corporate training solutions worldwide."
  },
  {
    id: "2",
    name: "Learning Dynamics",
    industry: "E-Learning",
    size: "100-500 employees", 
    logo: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=50&h=50&fit=crop",
    followers: 8900,
    description: "Innovative e-learning platform transforming professional development."
  }
];

export const mockMessages = [
  {
    id: "1",
    sender: {
      name: "Alex Rodriguez",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&h=50&fit=crop&crop=face",
      title: "Corporate Training Manager"
    },
    lastMessage: "Thanks for connecting! I'd love to discuss the training methodologies you mentioned.",
    time: "2h ago",
    unread: true
  },
  {
    id: "2",
    sender: {
      name: "Lisa Zhang",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=50&h=50&fit=crop&crop=face",
      title: "L&D Specialist"
    },
    lastMessage: "The conference was amazing! Did you get a chance to attend the VR training session?",
    time: "1 day ago",
    unread: false
  }
];

export const mockNotifications = [
  {
    id: "1",
    type: "like",
    message: "Alex Rodriguez and 15 others liked your post",
    time: "1h ago",
    unread: true
  },
  {
    id: "2", 
    type: "comment",
    message: "Lisa Zhang commented on your post about microlearning",
    time: "3h ago",
    unread: true
  },
  {
    id: "3",
    type: "connection",
    message: "David Kumar accepted your connection request",
    time: "1 day ago",
    unread: false
  }
];

export const mockGroups = [
  {
    id: "1",
    name: "Corporate Training Professionals",
    members: 45200,
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=100&h=100&fit=crop",
    description: "A community for corporate trainers to share best practices and connect"
  },
  {
    id: "2",
    name: "E-Learning Innovators",
    members: 28900,
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=100&h=100&fit=crop",
    description: "Discussing the latest trends in digital learning and instructional design"
  },
  {
    id: "3",
    name: "Leadership Development Network",
    members: 67800,
    image: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=100&h=100&fit=crop",
    description: "For professionals focused on developing tomorrow's leaders"
  }
];

export const mockEvents = [
  {
    id: "1",
    title: "Future of Training Conference 2024",
    date: "March 15, 2024",
    time: "9:00 AM - 5:00 PM",
    location: "Virtual Event",
    attendees: 1250,
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=300&h=200&fit=crop",
    description: "Join industry leaders discussing the latest trends in training and development"
  },
  {
    id: "2",
    title: "Microlearning Workshop",
    date: "March 22, 2024", 
    time: "2:00 PM - 4:00 PM",
    location: "New York, NY",
    attendees: 85,
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=300&h=200&fit=crop",
    description: "Hands-on workshop on creating effective microlearning modules"
  }
];

export const skills = [
  "Leadership Training",
  "Corporate Training", 
  "E-Learning",
  "Curriculum Development",
  "Adult Learning Theory",
  "Instructional Design",
  "Training Facilitation",
  "Performance Management",
  "Organizational Development",
  "Change Management",
  "Team Building",
  "Coaching & Mentoring",
  "Virtual Training",
  "Learning Analytics",
  "Microlearning",
  "Gamification",
  "VR/AR Training",
  "Mobile Learning",
  "Assessment Design",
  "Training ROI"
];